import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionModal from 'components/Modal/ActionModal';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useApolloClient } from '@apollo/client';
import { REMOVE_CENTER_DOCUMENT } from '../../../operations-gql/mutations';
import { FIND_CENTER_DOCUMENTS } from '../../../operations-gql/queries';

import { toast } from 'components/global/CUK/Toast/Toast';

const RemoveDocument: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const client = useApolloClient();
  const [removeCenterDocument, { loading }] = useMutation(REMOVE_CENTER_DOCUMENT);

  const handleClose = () => {
    navigate({ pathname: '/documents/center' });
  };

  const handleConfirmation = async () => {
    try {
      const { data } = await removeCenterDocument({ variables: { id } });
      if (data.removeCenterDocument.status) {
        toast.success(t('documents.edition.toaster.deletion_success'));
        await client.refetchQueries({
          include: [FIND_CENTER_DOCUMENTS],
        });
      } else {
        toast.error(t('documents.edition.toaster.deletion_error'));
      }
    } catch (err) {
      toast.error(t('documents.edition.toaster.deletion_error'));
    } finally {
      handleClose();
    }
  };

  return (
    <ActionModal
      cancelLabel={t('documents.edition.buttons.cancel')}
      confirmLabel={t('documents.edition.buttons.delete')}
      description={t('documents.edition.content.delete_confirm_content')}
      icon={<i className="fa-regular fa-trash" />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleConfirmation}
      title={t('documents.edition.content.warn')}
    />
  );
};

export default RemoveDocument;